import React, { useRef } from "react";
import InputBoxes from "../common/InputBoxes";
import { checkChildrenAndSetFocus } from "../common/interactiveCommon";
const KS2ContactInfo = (props) => {
  const { day, mobile, setContactNumber } = props;
  const dayDivRef = useRef(null);
  const mobileDivRef = useRef(null);
  const onTextChange = (e) => {
    const { name, value } = e.target
    const index = name.replace("DAY", "").replace("mobile", "");
    if (name.indexOf("DAY") >= 0) {
      checkChildrenAndSetFocus(dayDivRef.current.children, index);
    }
    if (name.indexOf("mobile") >= 0) {
      checkChildrenAndSetFocus(mobileDivRef.current.children, index);
    }
    setContactNumber({ name, value });
  };
  return (
    <div className="row">
      <div className="col-sm-12 col-md-12 col-lg-12 section-number-box">
        <div className="mb-3 number">6.</div>
        <div className="details">
          <div className="form-group form-inline">
            <div className=" col-md-2 section-label">
              <label className="">Your contact number</label>
            </div>

            <div className="col-md-10">
              <div className="row">
                <div className="col-md-5 section-form-group-inline" ref={dayDivRef}>
                  <InputBoxes keyName={"DAY"} name={day} count={9} onTextChange={onTextChange} upperCase={false} marginCellNo={[1,4]} />
                  <small className="small-title-label d-flex small-label">Day</small>
                </div>

                <div className="col-md-6 section-form-group-inline" ref={mobileDivRef}>
                  <InputBoxes keyName={"mobile"} name={mobile} count={11} onTextChange={onTextChange} upperCase={false} marginCellNo={[2,5]} />
                  <small className="small-title-label d-flex small-label">Mobile</small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default KS2ContactInfo;
